<template>
  <div>
    <div class="dovemed-card mob-no-shadow">
      <h3 :style="{ display: 'flex', 'margin-top': '24px', 'font-size': '32px', 'font-weight': '700', color: '#0F1734' }">Treatments A-Z</h3>

      <div class="search-container w-100">
        <!-- <form action="" @submit.prevent="searchTreatments" class="w-100">
          <a-input
            type="search"
            class="search-input-state w-100"
            placeholder="Search something..."
            :value="searchKey"
            @change="handleTreatmentSearch"
            :style="{
              'background-color': '#f1f5f9 !important',
              border: 'none !important',
              'border-radius': '8px !important'
            }"
          >
            <template #prefix>
              <a-icon
                class="svg-icon-size cp pr-3"
                :style="{ color: getPrimaryColor() }"
                :fill="getPrimaryColor()"
                type="search"
                :size="'large'"
                @click="searchTreatments"
              />
            </template>
            <template #suffix>
              <a-icon
                class="svg-icon-size cp"
                type="close"
                :size="'large'"
                @click="handleClearSearchWord"
              />
            </template>
          </a-input>
        </form> -->

        <form @submit.prevent="searchTreatments" class="w-100 d-flex align-items-center searchContainer">
          <font-awesome-icon :icon="['fal', 'search']" :style="{ color: getPrimaryColor() }" @click="searchTreatments" class="cp pr-3 ml-3" />
          <input type="text" class="search-input-state w-100" placeholder="Search something" :value="searchKey" @input="handleTreatmentSearch" :style="{ 'font-weight': searchKey ? '700' : '400' }" />
          <a-icon v-if="searchKey" class="svg-icon-size cp mr-3" type="close" :size="'large'" @click="handleClearSearchWord" />
        </form>

        <button type="submit" class="search-button font-white primary-button position-relative" :style="{ background: '#F1F5F9', border: 'none !important', flex: 1 }" @click="handleFilterBtn">
          <img src="../../assets/icons/bars-filter-light.png" alt="filter" class="hw24" />
          <span class="gray900 show-in-mobile fw700 font14 ml-3">Apply Filters</span>
          <div v-if="type !== 'all'" class="active-filter-indicator" :style="{ background: getPrimaryColor() }" />
        </button>
      </div>

      <treatment-filter :handleAnswer="handleAnswer" ref="TreatmentFilterModal" />
      <!-- :key="type" -->
      <!-- :type="type" -->

      <!-- FOR MULTI FILTERS -->
      <!-- <div
        class="w-100 appliedFiltersContainer"
        v-if="appliedFilters.length > 0"
      >
        <p class="m-auto gray500 fw700 font14">Applied Filters:</p>
        <div class="flex-grow-1 d-flex">
          <div
            class="eachAppliedFilter ml-2"
            v-for="appliedFilter in appliedFilters"
            :key="appliedFilter"
          >
            {{ appliedFilter }}
            <a-icon
              type="close"
              :size="'small'"
              class="cp"
              @click="handleDeleteFilter(appliedFilter)"
            />
          </div>
        </div>
        <p @click="handleClearFilters" class="textLast cp">Clear Filters</p>
      </div> -->

      <!-- FOR SINGLE FILTER -->
      <div class="w-100 appliedFiltersContainer" v-if="type !== 'all'">
        <p class="m-auto gray500 fw700 font14 hide-in-mobile">Applied Filters:</p>
        <div class="flex-grow-1 d-flex">
          <div class="eachAppliedFilter ml-2 text-capitalize fw700 font14">
            {{ getFilterTag(type) }}
            <a-icon type="close" :size="'small'" class="cp" @click="handleClearFilters" />
          </div>
          <div class="eachAppliedFilter ml-2 text-capitalize fw700 font14" v-if="selectedProcedureSubType && type === 'Procedure'">
            {{ selectedProcedureSubType }}
            <a-icon type="close" :size="'small'" class="cp" @click="handleClearProcedureFilter" />
          </div>
        </div>
        <p @click="handleClearFilters" class="m-auto cp font14" :style="{ color: getPrimaryColor() }">Clear Filters</p>
      </div>
    </div>

    <template v-if="type !== 'all'">
      <!-- THE TREAMENTS -->
      <h5 class="fw700 gray900 font20 mb-3 mt-5 m-ml16" v-if="treatments.length">
        <!-- {{ isLoadingData ? "0" : pagination.filter_count }} Results -->
        {{ isLoadingData ? "0" : pagination.filter_count }} Results
        <!-- {{ isLoadingData ? "0" : searchKey ? treatments.length : pagination.filter_count }} Results -->
      </h5>

      <!-- LOADING -->
      <div v-if="isLoadingData" class="d-flex justify-content-center mt-3">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-14px', 'margin-top': '40px' }">Loading...</div>
      </div>

      <div class="row m-0 treatmentsContainer justify-content-between" v-if="treatments && !isLoadingData">
        <div
          class="d-flex justify-content-between cp treatmentCard align-items-center p-2"
          v-for="treatment in treatments"
          :key="treatment.id"
          @click="$router.push({ name: 'Treatment', params: { id: `${treatment.id}`, type: `${type}` } })"
        >
          <div class="imgBox">
            <img v-if="treatment.url" :src="treatment.resized_images ? treatment.resized_images.dov640x320 : treatment.url" class="medImg" alt="image" />
            <!-- <img v-else src="../../assets/images/default-treatment-thumbnail.png" class="medImg" /> -->
            <img v-else :src="getMedImg" class="medImg" alt="image" />
            <!-- <div v-else class="emptySpace"/> -->
          </div>
          <p class="fw700 flex-grow-1">
            {{ treatment.display_name }}
          </p>
          <div class="text-decoration-none my-auto">
            <font-awesome-icon size="2x" class="arrow" :style="{ color: getPrimaryColor() }" :icon="['far', 'arrow-right']" />
          </div>
        </div>
        <!-- <p v-if="!treatments && !isLoadingData">
        There are no treatments found. Check again later.
      </p> -->
      </div>

      <!-- <div :style="{ 'text-align': 'center' }" v-if="!isLoadingData && !treatments.length">There are no treatments found. Check again later.</div> -->

      <div class="p-4 bg-gray100 br8 d-flex flex-column gap8 align-items-center w-100" v-if="!isLoadingData && !treatments.length">
        <font-awesome-icon :icon="['fas', 'search']" :style="{ color: getPrimary300Color() }" class="font20 bg-white p-4 rounded-circle" />
        <h5 class="gray900 fw700 font20">No Results Found</h5>
        <p class="mb-0 gray700 font14 text-center">
          We couldn’t find any results based on your search. <br />
          Please try searching with another term.
        </p>
      </div>

      <!-- PAGINATION -->
      <!-- v-if="treatments.length" -->
      <a-pagination
        v-if="!isLoadingData && pagination.filter_count > 16"
        v-model="currentPage"
        :total="pagination.filter_count ? pagination.filter_count : 0"
        show-less-items
        :pageSize="16"
        @change="handleChangePage"
        class="d-flex justify-content-center mt-3"
      />
    </template>

    <template v-else>
      <TreatmentsGroup
        v-for="eachType in allTypes"
        :key="eachType.name"
        :title="eachType.name"
        :type="eachType.type"
        :handleTreatmentClick="handleTreatmentClick"
        :handleTypeClick="handleAnswer"
        :searchWord="allSearchKeyWord"
        :handleAllEmpty="handleAllEmpty"
      />
      <div class="p-4 bg-gray100 br8 d-flex flex-column gap8 align-items-center w-100" v-if="allEmpty">
        <font-awesome-icon :icon="['fas', 'search']" :style="{ color: getPrimary300Color() }" class="font20 bg-white p-4 rounded-circle" />
        <h5 class="gray900 fw700 font20">No Results Found</h5>
        <p class="mb-0 gray700 font14 text-center">
          We couldn’t find any results based on your search. <br />
          Please try searching with another term.
        </p>
      </div>
    </template>

    <!-- <treatment-filter /> -->
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory"
import { mapGetters } from "vuex"
import TreatmentFilter from "../Modals/TreatmentFilter.vue"
import TreatmentsGroup from "./treatments/TreatmentsGroup.vue"
const AppRepository = RepositoryFactory.get("app")

export default {
  data() {
    return {
      isLoadingData: false,
      searchKey: null,
      type: "all",
      treatments: [],
      pagination: { filter_count: 0, total_count: 0 },
      currentPage: 1,
      itemLimit: 10,
      appliedFilters: [],
      allTypes: [
        { name: "Medication", type: "others", empty: false },
        { name: "Procedures", type: "Procedure", empty: false },
        { name: "Activity", type: "activity", empty: false },
        { name: "Complimentary Therapies", type: "nonmedicaltreatments", empty: false },
        { name: "Nutrition & Diet", type: "nutrition", empty: false },
      ],
      selectedProcedureSubType: undefined,
      allSearchKeyWord: "",
      allEmpty: false,
    }
  },

  components: {
    TreatmentFilter,
    TreatmentsGroup,
  },

  updated() {
    // console.log("Treatments updated");
  },

  created() {
    // console.log("Treatments created")
    // console.log("store pro ->", this.procedureSearch)
  },

  watch: {
    "$route.query.type": {
      handler(v) {
        // console.log("watching ->", v);
        this.type = v
      },
    },
  },

  mounted() {
    // this.getAllTreatments(this.currentPage, this.itemLimit);
    // console.log(
    //   "Treatments -> Mounted -> this.treatmentSearch ==",
    //   this.treatmentSearch
    // );
    this.searchKey = this.treatmentSearch
    // this.searchKey = "";
    // console.log("Treatments mounted")
    // console.log("store pro ->", this.procedureSearch)
    // console.log("Treatment scrolling...");
    this.selectedProcedureSubType = this.procedureSearch
    window.scrollTo(0, 0)
    this.type = this.$route.query.type
    this.searchTreatments("", 1)
  },

  computed: {
    ...mapGetters({
      treatmentSearch: "App/treatmentSearch",
      procedureSearch: "App/procedureSearch",
    }),
    getMedImg() {
      switch (this.type.toLowerCase()) {
        case "activity":
        case "activitys":
        case "activities":
          return require("../../assets/images/activity.png")
        case "procedure":
        case "procedures":
          return require("../../assets/images/procedure.png")
        case "nonmedicaltreatment":
        case "nonmedicaltreatments":
        case "therapy":
        case "therapys":
        case "therapies":
        case "complimentary therapy":
        case "complimentary therapys":
        case "complimentary therapies":
        case "complementary therapy":
        case "complementary therapys":
        case "complementary therapies":
          return require("../../assets/images/complementary.png")
        case "other":
        case "others":
        case "medication":
        case "medications":
          return require("../../assets/images/medication.png")
        case "nutritions & diets":
        case "nutritions & diet":
        case "nutrition & diets":
        case "nutrition & diet":
        case "nutrition":
          return require("../../assets/images/nutrition.png")
        default:
          return require("../../assets/images/default-treatment-thumbnail.png")
      }
    },
  },

  methods: {
    handleAllEmpty(type, isEmpty = false) {
      this.allTypes = this.allTypes.map(item => ({
        ...item,
        empty: item.type === type ? isEmpty : item.empty,
      }))
      this.allEmpty = this.allTypes.every(item => item.empty === true)
    },
    getFilterTag(type) {
      switch (type.toLowerCase()) {
        case "others":
          return "Medications"
        case "nonmedicaltreatments":
          return "Complimentary Therapies"
        case "nutrition":
          return "Nutrition & Diet"
        case "procedure":
        case "procedures":
          return "Procedures"
        case "activity":
        case "activitys":
        case "activities":
          return "Activities"
        default:
          return type
      }
    },
    handleTreatmentClick(selectedTreatment, selectedType) {
      this.$router.push({ name: "Treatment", params: { id: `${selectedTreatment.id}`, type: `${selectedType}` } })
    },
    // handleTypeClick(selectedType) {},
    // handleDeleteFilter(currentFilter) {
    //   this.appliedFilters = this.appliedFilters.filter(
    //     eachFilter => eachFilter !== currentFilter
    //   );
    // },
    handleClearSearchWord() {
      this.searchKey = ""
      this.$store.commit("App/setTreatment", "")
      this.searchTreatments("", 1)
    },
    handleClearFilters() {
      // this.appliedFilters = []
      this.type = "all"
      this.$router.push({ name: this.$route.name, query: { type: "all" } })
      this.handleClearSearchWord()
    },
    handleClearProcedureFilter() {
      this.selectedProcedureSubType = ""
      this.searchTreatments("", 1)
    },
    handleFilterBtn() {
      this.$refs.TreatmentFilterModal.show(this.procedureSearch)
    },
    handleAnswer(ans = "", procedureSubType, cleared = false) {
      if (cleared || ans === "all") {
        this.type = "all"
        this.$router.push({ name: this.$route.name, query: { type: "all" } })
        this.handleClearSearchWord()
      } else {
        this.type = ans
        this.selectedProcedureSubType = procedureSubType
        this.$store.commit("App/setProcedure", procedureSubType)
        this.searchTreatments("", 1)
      }
    },
    handleChangePage(page) {
      this.currentPage = page
      this.searchTreatments("", page)
    },
    handleTreatmentSearch(e) {
      this.$store.commit("App/setTreatment", e.target.value)
      this.searchKey = e.target.value
      // console.log(this.searchKey, "<- searchKey");
    },
    // handleTreatmentType(e) {
    //   this.currentPage = 1;
    //   this.type = e.target.value;
    //   this.searchTreatments("", 1);
    // },
    searchTreatments(val, page = 1) {
      this.allSearchKeyWord = this.searchKey
      this.isLoadingData = true
      this.$router.push({ name: this.$route.name, query: { type: this.type } })
      if (this.type === undefined) {
        this.$notification.warning({ message: "Error", description: `Please select a type` })
        this.isLoadingData = false
        return
      } else if (this.type === "nonmedicaltreatments") {
        AppRepository.searchNonmedicaltreatments(this.searchKey || "", this.currentCircle.id, null, page)
          .then(res => {
            // this.treatments = res.data.data.map(ele => {
            //   ele.display_name = ele.display_name.toLowerCase()
            //   return ele
            // })
            this.treatments = res.data.data
            this.pagination = res.data.paginator
            this.isLoadingData = false
          })
          .catch(err => {
            this.isLoadingData = false
          })
      } else if (this.type !== "all") {
        AppRepository.searchTreatments(this.searchKey ? this.searchKey : "", this.currentCircle.id, this.type, page, 16, this.selectedProcedureSubType)
          .then(res => {
            if (res.data) {
              if (this.type === "others") {
                // this.treatments = res.data.data
                //   ? res.data.data.extra_treatments.map(ele => {
                //       ele.display_name = ele.display_name.toLowerCase()
                //       return ele
                //     })
                //   : []
                this.treatments = res.data.data ? res.data.data.extra_treatments : []
                this.pagination = res.data.data.pagination
                // console.log("pagination ->", this.pagination)
              } else {
                // this.treatments = res.data.data.circle_treatments.map(ele => {
                //   ele.display_name = ele.display_name.toLowerCase()
                //   return ele
                // })
                this.treatments = res.data.data.circle_treatments
                this.pagination = res.data.data.pagination
              }
            } else {
              if (res.status === 204) {
                this.treatments = []
              }
            }
            this.isLoadingData = false
          })
          .catch(err => {
            this.isLoadingData = false
          })
      } else {
        this.isLoadingData = false
      }
      window.scrollTo(0, 0)
    },

    getAllTreatments(page, limit) {
      this.isLoadingData = true
      AppRepository.getAllTreatments(page, limit, this.currentCircle.id)
        .then(res => {
          this.treatments = res.data.data.data
          this.pagination = res.data.data.paginator
          // console.log("pagination ->", this.pagination)
        })
        .catch(err => null)
      this.isLoadingData = false
    },
  },
}
</script>

<style lang="scss" scoped>
.anticon-search {
  svg {
    fill: #2a71d4 !important;
  }
}
.arrow {
  transform: scale(0.7);
}
.search-container {
  display: flex;
  margin-top: 24px;
  gap: 24px;

  .search-input-state {
    background: none;
    border-left: 0 !important;
    height: 60px;
    outline: none;

    &:focus {
      outline: none;
    }
  }

  .search-button {
    max-width: 60px;
    min-width: 60px;
    border-radius: 8px;

    &:focus {
      outline: none;
    }
  }
}

.active-filter-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  align-self: flex-start;
  margin-top: 18px;
  margin-left: 5px;
  @media screen and (min-width: 701px) {
    top: 0;
    right: 0;
    position: absolute;
    margin-right: 10px;
    margin-top: 15px;
  }
}

.searchContainer {
  background-color: #f1f5f9 !important;
  border-radius: 8px !important;
  border: none !important;

  input {
    border: none !important;
  }
}

.appliedFiltersContainer {
  display: flex;
  margin-top: 24px;
  justify-content: space-between;
  align-items: center;

  .eachAppliedFilter {
    background: #f1f5f9;
    border-radius: 6px;
    padding: 12px;
    display: flex;
    align-items: center;
    color: #0f1734;
    gap: 12px;
  }
}

.treatmentCard {
  // padding: 24px;
  // background: #f1f5f9;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin-bottom: 24px;
  max-width: 48.5%;
  flex-basis: 48.5%;
  gap: 16px;

  @media screen and (max-width: 600px) {
    width: 100%;
    flex-basis: auto;
    max-width: 100%;
    margin: 12px 16px;
  }

  &:hover {
    background: #daebfc;
  }

  p {
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    color: #1e2945 !important;
    margin-bottom: 0;
    align-self: center;
  }
}
@media screen and (max-width: 581px) {
  .search-container {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .search-input {
      width: 100%;
      margin-bottom: 5px;
      border-radius: 8px;
      &-state {
        width: 100%;
        border-radius: 8px;
        margin-bottom: 5px;
      }
    }
    .search-button {
      // border-radius: 8px;
      min-width: 100%;
      margin: auto;
      min-height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .svg-icon-size {
    font-size: 20px;
  }
}
.medImg {
  height: 50px;
  // max-height: 50px;
  margin: auto;
  object-fit: cover;
  width: 100%;
  // max-width: 100%;
}
.emptySpace,
.imgBox {
  height: 50px;
  min-width: 85px;
  max-width: 85px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Treatments.vue